// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + "settings-vendors" + "-" + "a6938087f8826d37" + ".js"
}